import { create } from 'zustand';
import i18n from 'i18n';
import { ApiUtils, GetMessagesThreadResponse, MessagesApi } from '@shared/api';
import type { BaseReturn } from '@shared/types';

interface UseMessagesThreadStore {
  loading: boolean;
  data: GetMessagesThreadResponse | null;
  error?: string | null;
  get: (threadId: string) => Promise<BaseReturn<any>>;
  clear: () => void;
}

export const useMessagesThreadStore = create<UseMessagesThreadStore>((set) => ({
  loading: false,
  data: null,
  error: null,

  get: async (threadId: string) => {
    try {
      set({ loading: true, data: null, error: null });
      const result = await MessagesApi.getMessagesThread(threadId);
      set({ loading: false, data: result ?? null });
      return { loading: false, data: result ?? null };
    } catch (e) {
      const error = i18n.t(`errors.api.${ApiUtils.getError(e)}`, ApiUtils.getError(e));
      set({ loading: false, data: null, error });
      return { loading: false, data: null, error };
    }
  },

  clear: () => set({ loading: false, data: null, error: null }),
}));
